<script setup lang="ts">
import { inject, onBeforeMount, ref, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import cloneDeep from 'lodash/cloneDeep';
import { PACKAGE, HOTEL_ONLY, AIR_ONLY } from '@/constants';
import Button from 'primevue/button';
import Fluid from 'primevue/fluid';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';

const dialogRef = inject('dialogRef') as Ref;
const data = dialogRef?.value?.options.data.expiryDate;
const type = dialogRef?.value?.options.data.type;
const isSave = dialogRef?.value?.options.emits.isSave;

const { t } = useI18n({ useScope: 'global' });
const showError = ref(false);
const cloneData = ref(cloneDeep(data));
const exclusions = ref([]);

const initData = () => {
  return {
    code: '',
    expiryDay: 0
  };
};

const save = () => {
  showError.value = true;
  const isValid = exclusions.value.every((exclusion) => exclusion.code.trim());
  if (isValid) {
    isSave(exclusions.value);
  }
};

const renderArrayExpiry = (exclusionData) => {
  return Object.keys(exclusionData).map((key) => ({ code: key, expiryDay: exclusionData[key] }));
};

onBeforeMount(() => {
  if (cloneData.value && Object.keys(cloneData.value).length) {
    exclusions.value = renderArrayExpiry(cloneData.value);
  } else {
    exclusions.value.push(initData());
  }
});

const addException = () => {
  exclusions.value.push(initData());
};

const deleteException = (indexDelete: number) => {
  exclusions.value = exclusions.value.filter((_, index) => index !== indexDelete);
};

const renderLabelInput = (typeLabel: string) => {
  switch (typeLabel) {
    case PACKAGE:
      return t('management.package.airport_code');
    case HOTEL_ONLY:
      return t('management.package.airport_code');
    case AIR_ONLY:
      return t('management.package.airport_code');
    default:
      return t('management.package.destination_id');
  }
};
</script>
<template>
  <div class="main exclusions-email-modal">
    <div class="mt-3">
      <Fluid class="relative">
        <div v-for="(exclusion, index) in exclusions" :key="index" class="flex justify-content-between list-config">
          <div class="mb-2 w-5">
            <label for="code">{{ renderLabelInput(type) }}</label>
            <InputText id="code" v-model="exclusion.code" :class="showError && !exclusion.code ? 'p-invalid' : ''" />
            <span v-if="!exclusion.code && showError" class="text-primary error-message">{{ $t('validate.required') }}</span>
          </div>
          <div class="flex align-items-center gap-2 w-6">
            <div class="mb-2">
              <label for="expiry-day">{{ $t('management.email.expiry_day') }}</label>
              <InputNumber id="expiry-day" :min="0" v-model="exclusion.expiryDay" />
            </div>
            <div class="flex">
              <i class="cursor-pointer pi pi-times-circle table-action-button text-primary mt-3" @click="deleteException(index)"></i>
            </div>
          </div>
        </div>
        <a href="javascript:" class="block text-primary text-right mb-3 link" @click="addException()">+ {{ $t('common.add') }}</a>
      </Fluid>
    </div>
    <div class="mt-5 text-center">
      <Button class="submit-btn" :label="$t('common.buttons.submit')" @click="save()" />
    </div>
  </div>
</template>
